var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"back":"edit-upload","title":_vm.$t('customization.changeImageEffect')}},[_c('collection',{attrs:{"designs":_vm.computedEffects},on:{"item-clicked":function($event){_vm.closeModalAfter(() => _vm.selectEffect($event))}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }